import { type IntlShape } from "react-intl";

/** A cost as the API sends it (a Decimal scalar: a number) in the lot's currency. */
export const formatCost = (
  amount: number | string | null | undefined,
  currency: string,
  intl: IntlShape,
): string => {
  if (amount === null || amount === undefined || amount === "") {
    return "";
  }

  const value = typeof amount === "number" ? amount : Number(amount);

  if (Number.isNaN(value)) {
    return String(amount);
  }

  return intl.formatNumber(value, { style: "currency", currency });
};

/** `+3`, `-2`, `0`. */
export const signed = (value: number): string => (value > 0 ? `+${value}` : String(value));

/** A SKU as the API keys it: trimmed, upper case. */
export const normalizeSku = (sku: string): string => sku.trim().toUpperCase();

/**
 * A money string typed into a form, as the number the API takes, or null
 * when it is not one (blank, letters, negative, more than two decimals).
 */
export const parseCost = (text: string): number | null => {
  const trimmed = text.trim().replace(/^\$/, "");

  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    return null;
  }

  return Number(trimmed);
};

/** A whole number typed into a form, or null. */
export const parseInteger = (text: string): number | null => {
  const trimmed = text.trim();

  if (!/^[+-]?\d+$/.test(trimmed)) {
    return null;
  }

  return Number(trimmed);
};
